import React from 'react';
import '../App.css';

import ViewPost from '../pages/ViewPost';
import ViewUser from '../pages/ViewUser';
import ShowData from '../pages/ShowData';

import AddPost from '../create/AddPost'
import AddCoins from './AddCoins'
import Invitation from './Invitation'

import Login from '../account/Login'
import Register from '../account/Register'
import MyProfile from '../account/MyProfile'
import DeleteUser from '../account/DeleteUser'
import SideBarContent from '../utils/SideBar/SideBar'
import TopBar from '../utils/TopBar'
import Sidebar from "react-sidebar";
import Username from '../account/Username'
import EditProfile from '../account/EditProfile'
import ForgotPassword from "../account/ForgotPassword"

import Settings from "../account/Settings"
import PrivacyPolicy from "../utils/ErrorPages/PrivacyPolicy"
import ChangeEmail from "../account/ChangeEmail"
import ChangePassword from "../account/ChangePassword"
import ChangeReferUser from "../account/ChangeReferUser"
//import DeleteUser from "../account/DeleteUser"

import { BrowserRouter as Router, Switch, Route, withRouter } from "react-router-dom"
import Download from '../pages/Download';
import TopUsers from '../utils/TopUsers/TopUsers';
import SideMenuMobile from '../utils/SideBar/SideMenuMobile';
import InviteFriends from '../account/InviteFriends';
import Achievements from '../account/Achievements';
import DailyRewards from '../account/DailyRewards';
import ScrollToTop from '../utils/Utilities/ScrollToTop';
import Search from './Search';
import Contact from './Contact';
import PageNotFound from '../utils/ErrorPages/PageNotFound';
/* import Collectables from './Collectables';
import AddCollectable from '../create/AddCollectable'; */
import ShowMessages from './ShowMessages';
import ViewMessage from './ViewMessage';

import AdminMain from '../admin/AdminMain';
import AdminCreateDummy from '../admin/AdminCreateDummy';
import Paypal from '../admin/Paypal';
import SocialMenu from '../utils/SideBar/SocialMenu';


class Navigation extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			windowWidth: 0,
			windowHeight: 0,
			docked: false,
			open: false,
			showTopBar: true,
			showSideBar: true,
		};
		this.toggleOpen = this.toggleOpen.bind(this);
		this.onSetOpen = this.onSetOpen.bind(this);
	}

	onSetOpen(open) {
		this.setState({ open });
	}

	onCloseSidebar = () => {
		this.setState({ open: false })
	}

	toggleOpen(ev) {
		this.setState({ open: !this.state.open });
		if (ev) {
			ev.preventDefault();
		}
	}

	topComponent = (props) => {
		return <ShowData type="top" {...props} />
	}

	latestComponent = (props) => {
		return <ShowData type="latest" {...props} />
	}

	trendingComponent = (props) => {
		return <ShowData type="trending" {...props} />
	}

	categoryComponent = (props, category) => {
		return <ShowData type="top" category={category} {...props} />
	}

	linkComponent = () => {
		return <ShowData link={true} />
	}

	render() {
		const TopBarr = withRouter((props) => {
			return <TopBar toggleOpen={this.toggleOpen} {...props} />
		})

		const SideBarr = withRouter((props) => {
			return <SideBarContent {...props}></SideBarContent>
		})

		return (

			<Router >

				<div className="App">
					<div style={{ display: "flex" }}>
						<Switch>
							<Route path="/paypal" exact render={(props) => <Paypal {...props} />} />
							<ScrollToTop>
								<Sidebar
									contentId="sideBar"
									className={"background-color"}
									styles={{ sidebar: { top: 60, overflowX: "hidden", backgroundColor: "white" } }}
									sidebar={<SideMenuMobile closeSidebar={this.onCloseSidebar} />}
									open={this.state.open}
									docked={false}
									onSetOpen={this.onSetOpen}
									//styles={{ sidebar: { overflowX: "hidden", } }} 
								>
									<TopBarr docked={this.state.docked} />
									<div id="Home" className="container-main" style={{ /* display: "flex", justifyContent: "space-between" */ }}>
										<aside className="side-bar-main " style={{ width: 310, minWidth: 310 }}>
											<div style={{ display: "flex", position: "fixed", top: 0, bottom: 0, marginLeft: 10, marginTop: 60/* marginTop: styles.topBarHeight, height: "100%", */ }}>
												<SideBarr match={this.props.match} />
											</div>
										</aside>
										<div id="main-component" style={{ display: "flex", width: "100%", maxWidth: 600, justifyContent: "center" }}>
											<Switch>
												<Route path="/" exact render={(props) => <ShowData {...props} type={"latest"} />} />
												<Route path="/top" render={(props) => <ShowData {...props} type={"top"} />} />
												<Route path="/latest" render={(props) => <ShowData {...props} type={"latest"} />} />
												<Route path="/trending" render={(props) => <ShowData {...props} type={"trending"} />} />
												<Route path="/user/:username" render={(props) => <ViewUser {...props} />} />
												<Route path="/user" render={(props) => <ViewUser {...props} />} />
												<Route path="/post/:id" render={(props) => <ViewPost {...props} />} />
												<Route path="/download" render={(props) => <Download {...props} />} />
												<Route path="/create" render={(props) => <AddPost {...props} />} />

												<Route path="/invitation" render={(props) => <Invitation {...props} />} />

												<Route path="/search" render={(props) => <Search {...props} />} />
												<Route path="/search/:searchText" render={(props) => <Search {...props} />} />

												<Route path="/account/profile" render={(props) => <MyProfile {...props} />} />
												<Route path="/account/recover" render={(props) => <ForgotPassword {...props} />} />
												<Route path="/settings" render={(props) => <Settings {...props} />} />
												<Route path="/account/password" render={(props) => <ChangePassword {...props} />} />
												<Route path="/account/email" render={(props) => <ChangeEmail {...props} />} />
												<Route path="/account/refer" render={(props) => <ChangeReferUser {...props} />} />
												<Route path="/account/invitefriends" render={(props) => <InviteFriends {...props} />} />
												<Route path="/account/achievements" render={(props) => <Achievements {...props} />} />
												<Route path="/account/daily" render={(props) => <DailyRewards {...props} />} />
												<Route path="/account/balance" render={(props) => <AddCoins {...props} />} />
												<Route path="/privacy" render={(props) => <PrivacyPolicy {...props} />} />
												<Route path="/contact" render={(props) => <Contact {...props} />} />

												<Route path="/account/login" render={(props) => <Login {...props} />} />
												<Route path="/account/register" exact render={(props) => <Register {...props} />} />
												<Route path="/account/register/username" render={(props) => <Username {...props} />} />
												<Route path="/account/edit" render={(props) => <EditProfile {...props} />} />
												<Route path="/account/delete" render={(props) => <DeleteUser {...props} />} />

												<Route path="/link/:id" render={(props) => <ShowData link={true} {...props} />} />
												<Route path="/hashtag/:tag/:type" render={(props) => <ShowData {...props} />} />
												<Route path="/hashtag/:tag" render={(props) => <ShowData {...props} />} />

												{/* <Route path="/requests" render={(props) => <Requests {...props} />} /> */}
												<Route path="/messages" render={(props) => <ShowMessages {...props} />} />
												<Route path="/message/:message" render={(props) => <ViewMessage {...props} />} />

												{/* <Route path="/addCollectable" render={(props) => <AddCollectable {...props} />} />
										<Route path="/collectables" render={(props) => <Collectables {...props} />} />
										<Route path="/collectables/:category" render={(props) => <Collectables {...props} />} /> */}


												<Route path="/admin/add" render={(props) => <AdminCreateDummy {...props} />} />
												<Route path="/admin" render={(props) => <AdminMain {...props} />} />
												<Route path="*" render={(props) => <PageNotFound {...props} />} />
											</Switch>
										</div>
										<div className="top-users-main" style={{ maxWidth: 300, minWidth: 200 }}>
											<TopUsers ></TopUsers>
											<SocialMenu></SocialMenu>
										</div>
									</div>
								</Sidebar>
							</ScrollToTop>
						</Switch>
					</div>
				</div>

			</Router>

		);
	}
}

export default Navigation;


